import {
  createApiFactory,
  createPlugin,
  createComponentExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { msDefenderApiRef, MsDefenderClient } from './api';

export const msDefenderPlugin = createPlugin({
  id: 'ms-defender',
  apis: [
    createApiFactory({
      api: msDefenderApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new MsDefenderClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const MSDefenderCard = msDefenderPlugin.provide(
  createComponentExtension({
    name: 'MSDefenderCard',
    component: {
      lazy: () =>
        import('./components/MSDefenderCard').then(
          m => m.MSDefenderCard,
        ),
    },
  }),
);